import { InputSignalWithTransform } from '@angular/core';
import { Observable } from 'rxjs';

export type DisplayWithFn<T> = (elem: T) => string;
export type DisplayWithSignal<T> = InputSignalWithTransform<
  DisplayWithFn<T>,
  DisplayWithFn<T>
>;
export type QueryFn<T> = (search: string) => Observable<T[]>;
export type GroupingFn<T> = (results: T[]) => NestedAutocompleteItem<T>[];
export const defaultDisplayFn: DisplayWithFn<unknown> = (elem) =>
  typeof elem === 'string'
    ? elem
    : elem instanceof String
      ? elem.toString()
      : JSON.stringify(elem);

export interface NestedAutocompleteItem<T> {
  text: string;
  value?: T;
  description?: string;
  icon?: string;
  items?: Omit<NestedAutocompleteItem<T>, 'items'>[];
}
